import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import es from './locales/es.json';
import ur from './locales/ur.json';
import tr from './locales/tr.json';
import id from './locales/id.json';
import bn from './locales/bn.json';
import so from './locales/so.json';
import zh from './locales/zh.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  ar: { translation: ar },
  es: { translation: es },
  ur: { translation: ur },
  tr: { translation: tr },
  id: { translation: id },
  bn: { translation: bn },
  so: { translation: so },
  zh: { translation: zh },
};

export const languages = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'ur', name: 'Urdu', nativeName: 'اردو', flag: '🇵🇰', rtl: true },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা', flag: '🇧🇩' },
  { code: 'so', name: 'Somali', nativeName: 'Soomaali', flag: '🇸🇴' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳' },
];

// Supported language codes for validation
const supportedLangCodes = languages.map(l => l.code);

// RTL language codes
const rtlLangCodes = languages.filter(l => l.rtl).map(l => l.code);

// Set document direction based on language
const setDocumentDirection = (lang) => {
  const isRtl = rtlLangCodes.includes(lang);
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: supportedLangCodes,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Set initial document direction on load
setDocumentDirection(i18n.language);

// Listen for language changes to update direction
i18n.on('languageChanged', (lng) => {
  setDocumentDirection(lng);
});

export default i18n;
